import { parseBoolean } from '@chatwoot/utils';
import { resolveMaximumFileUploadSize } from 'shared/helpers/FileHelper';

const normalizeBrandAssetLogo = logoPath => {
  if (typeof logoPath !== 'string') {
    return logoPath;
  }

  return logoPath.replace(
    /(\/brand-assets\/logo(?:_dark|_thumbnail)?)\.svg(\?.*)?$/,
    '$1.png$2'
  );
};

const normalizeBrandAssetThumbnail = thumbnailPath => {
  if (typeof thumbnailPath !== 'string') {
    return thumbnailPath;
  }

  return thumbnailPath.replace(
    /(\/brand-assets\/logo_thumbnail)\.png(\?.*)?$/,
    '$1.svg$2'
  );
};

const {
  API_CHANNEL_NAME: apiChannelName,
  API_CHANNEL_THUMBNAIL: apiChannelThumbnail,
  APP_VERSION: appVersion,
  AZURE_APP_ID: azureAppId,
  BRAND_NAME: brandName,
  CHATWOOT_INBOX_TOKEN: chatwootInboxToken,
  CREATE_NEW_ACCOUNT_FROM_DASHBOARD: createNewAccountFromDashboard,
  DIRECT_UPLOADS_ENABLED: directUploadsEnabled,
  DISPLAY_MANIFEST: displayManifest,
  GIT_SHA: gitSha,
  IDLE_LOGOUT_MINUTES: idleLogoutMinutes,
  MAXIMUM_FILE_UPLOAD_SIZE: maximumFileUploadSize,
  SINGLE_ACTIVE_DASHBOARD_TAB: singleActiveDashboardTab,
  HCAPTCHA_SITE_KEY: hCaptchaSiteKey,
  INSTALLATION_NAME: installationName,
  LOGO_THUMBNAIL: logoThumbnail,
  LOGO: logo,
  LOGO_DARK: logoDark,
  PRIVACY_URL: privacyURL,
  IS_ENTERPRISE: isEnterprise,
  TERMS_URL: termsURL,
  WIDGET_BRAND_URL: widgetBrandURL,
  DISABLE_USER_PROFILE_UPDATE: disableUserProfileUpdate,
  DISABLE_META_INBOX_CREATION: disableMetaInboxCreation,
  DISABLE_META_MESSAGE_SENDING: disableMetaMessageSending,
  DEPLOYMENT_ENV: deploymentEnv,
  ACTIVE_PLATFORM_BANNERS: activePlatformBanners,
} = window.globalConfig || {};

const state = {
  apiChannelName,
  apiChannelThumbnail,
  appVersion,
  azureAppId,
  brandName,
  chatwootInboxToken,
  deploymentEnv,
  createNewAccountFromDashboard,
  directUploadsEnabled: parseBoolean(directUploadsEnabled),
  disableUserProfileUpdate: parseBoolean(disableUserProfileUpdate),
  disableMetaInboxCreation: parseBoolean(disableMetaInboxCreation),
  disableMetaMessageSending: parseBoolean(disableMetaMessageSending),
  displayManifest,
  gitSha,
  idleLogoutMinutes: Number(idleLogoutMinutes) || 0,
  maximumFileUploadSize: resolveMaximumFileUploadSize(maximumFileUploadSize),
  singleActiveDashboardTab: parseBoolean(singleActiveDashboardTab),
  hCaptchaSiteKey,
  installationName,
  logo: normalizeBrandAssetLogo(logo),
  logoDark: normalizeBrandAssetLogo(logoDark),
  logoThumbnail: normalizeBrandAssetThumbnail(logoThumbnail),
  privacyURL,
  termsURL,
  widgetBrandURL,
  isEnterprise: parseBoolean(isEnterprise),
  activePlatformBanners: activePlatformBanners || [],
};

export const getters = {
  get: $state => $state,
  isOnChatwootCloud: $state => $state.deploymentEnv === 'cloud',
  isMetaInboxCreationDisabled: $state =>
    $state.deploymentEnv === 'cloud' && $state.disableMetaInboxCreation,
  isMetaMessageSendingDisabled: $state =>
    $state.deploymentEnv === 'cloud' && $state.disableMetaMessageSending,
  isACustomBrandedInstance: $state => $state.installationName !== 'Chatwoot',
  isAChatwootInstance: $state => $state.installationName === 'Chatwoot',
};

export const actions = {};

export const mutations = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
